import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import './index.css';
import App from './App';

if (`${process.env.REACT_APP_ENV}` !== 'local' && `${process.env.REACT_APP_ENV}` !== 'dev') {
  Sentry.init({
    dsn: 'https://3f68f1b5f7a24aeca88e06382bff677e@o1008467.ingest.sentry.io/5976405',
    release: `ventureraise-ui@${process.env.REACT_APP_VERSION}+${process.env.REACT_APP_SHA}`,
    environment: `${process.env.REACT_APP_ENV}`,
    integrations: [new Integrations.BrowserTracing()],
    tunnel: `${process.env.REACT_APP_API_URL}/sentry/tunnel`, // Add blockers, see https://docs.sentry.io/platforms/javascript/troubleshooting/#dealing-with-ad-blockers
    tracesSampleRate: 1.0
  });
}

ReactDOM.render(
  <React.StrictMode>
    <Router>
      <App />
    </Router>
  </React.StrictMode>,
  document.getElementById('root')
);
